import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tender-bill-form',
  templateUrl: './tender-bill-form.component.html',
  styleUrls: ['./tender-bill-form.component.css']
})
export class TenderBillFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/billing/tender-bill/tender-bill-form/tender-bill-form.component.ts